import { LANGUAGE_JAPANESE_OPTIONS } from '@/constants/enums/Language'

// convertAndJoinLocalesToJapaneseLabelはvueファイル以外でも呼び出す想定なので、useI18nConstantsで用意しているgetLocaleJapaneseLabelを使えない
const getLocaleJapaneseLabel = (locale: string) => {
  return LANGUAGE_JAPANESE_OPTIONS.find(item => item.value === locale)?.title || ''
}

export const convertAndJoinLocalesToJapaneseLabel = (locales: string[]) => {
  const convertedErrorLocales = locales.map(locale => getLocaleJapaneseLabel(locale))
  return convertedErrorLocales.join('、')
}
